include ../../../../common/primary/icon/icon.mixin.pug

.fp-presentation-card--image-badge(v-if='auctionLot.auction.status === "UPCOMING"' data-test='upcoming-time-left')
  +fp-icon('clock', {size: '16', color: 'shade-500'})
  .fp-presentation-card--image-badge-text
    .fp-text.-text-xs {{ t('marketplace.auction.startsIn') }}
    code.fp-text.-text-xs.-text-semi-bold {{ countdownBeforeStartDate.daysLeft + t('countdown.shortDays') }} {{ countdownBeforeStartDate.hoursLeft + t('countdown.shortHours') }} {{ countdownBeforeStartDate.minutesLeft + t('countdown.shortMinutes') }} {{ countdownBeforeStartDate.secondsLeft + t('countdown.shortSeconds') }}
.fp-presentation-card--image-badge(v-if='auctionLot.auction.status === "ACTIVE" && auctionLot.bids.length' data-test='active-last-bid' :class='{ "-success": auctionLot.bids[0].bidder.me }')
  .fp-image.-circled.-sm
    BidderImageVue(:bidder='auctionLot.bids[0].bidder')
  .fp-presentation-card--image-badge-text
    .fp-text.-text-xs {{ t('marketplace.auction.currentDonation') }}
    .fp-text.-text-xs.-text-semi-bold
      BidderIdentityVue(:bidder='auctionLot.bids[0].bidder')
.fp-presentation-card--image-badge(v-if='auctionLot.auction.status === "ACTIVE" && auctionLot.bids.length === 0' data-test='active-no-bid')
  +fp-icon('gavel', {size: '16', color: 'shade-500'})
  .fp-presentation-card--image-badge-text
    .fp-text.-text-xs {{ t('marketplace.auction.noDonation') }}
    .fp-text.-text-xs.-text-semi-bold {{ t('marketplace.auction.beFirst') }}
.fp-presentation-card--image-badge(v-if='auctionLot.auction.status === "CLOSED" && auctionLot.bids.length' data-test='closed-last-bid' :class='{ "-success": auctionLot.bids[0].bidder.me }')
  .fp-image.-circled.-sm
    BidderImageVue(:bidder='auctionLot.bids[0].bidder')
  .fp-presentation-card--image-badge-text
    .fp-text.-text-xs {{ t('marketplace.auction.wonBy') }}
    .fp-text.-text-xs.-text-semi-bold
      BidderIdentityVue(:bidder='auctionLot.bids[0].bidder')
.fp-presentation-card--image-badge(v-if='auctionLot.auction.status === "CLOSED" && auctionLot.bids.length === 0' data-test='closed-no-bid')
  +fp-icon('gavel', {size: '16', color: 'shade-500'})
  .fp-presentation-card--image-badge-text
    .fp-text.-text-xs {{ t('marketplace.auction.auctionClosed') }}
    .fp-text.-text-xs.-text-semi-bold {{ t('marketplace.auction.noBidder') }}
